import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgReminder = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M32 50.333c9.113 0 16.5-7.387 16.5-16.5s-7.387-16.5-16.5-16.5-16.5 7.388-16.5 16.5 7.387 16.5 16.5 16.5"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M47.125 33.833c0-8.353-6.772-15.125-15.125-15.125S16.875 25.48 16.875 33.833 23.647 48.958 32 48.958s15.125-6.771 15.125-15.125m2.75 0c0 9.873-8.003 17.875-17.875 17.875s-17.875-8.002-17.875-17.875S22.128 15.958 32 15.958s17.875 8.003 17.875 17.875"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M30.625 26.5a1.375 1.375 0 1 1 2.75 0v6.764l4.18 4.18a1.375 1.375 0 1 1-1.944 1.945l-4.583-4.584a1.38 1.38 0 0 1-.403-.972zM23.02 12.5a1.374 1.374 0 1 1 1.457 2.331l-7.333 4.583a1.374 1.374 0 1 1-1.457-2.33zm16.063.437a1.374 1.374 0 0 1 1.894-.437l7.334 4.583a1.374 1.374 0 1 1-1.458 2.331l-7.333-4.583a1.374 1.374 0 0 1-.437-1.894"
      />
    </svg>
  );
};
export default SvgReminder;
